import { useEffect, useRef, useState } from 'react';
import {
  ICheckInvoiceStatusReq,
  InvoiceStatus,
} from '@models/interfaces/user.interface';
import { useMutation } from '@tanstack/react-query';
import userServicesServices from '@services/GeniebookAPI/UserServices.services';

export type IInvoiceStatus = null | 'success' | 'error' | 'in-progress';
export function useInvoiceStatus(data: ICheckInvoiceStatusReq) {
  const polling = useRef<ReturnType<typeof setInterval>>();
  const [status, setStatus] = useState<IInvoiceStatus>();

  const checkPaymentStatusMutation = useMutation({
    mutationFn: async (formData: ICheckInvoiceStatusReq) => {
      return userServicesServices.checkInvoiceStatus(formData);
    },
    onMutate: () => {
      setStatus('in-progress');
    },
    onSuccess: ({ data }) => {
      if (data.error) {
        clearInterval(polling.current);
        setStatus('error');
      } else {
        if (data.invoice_status == InvoiceStatus.completed) {
          clearInterval(polling.current);
          setStatus('success');
        }
      }
    },
  });

  useEffect(() => {
    if (
      data.subscription_invoice_id &&
      data.subject_id &&
      polling.current == undefined
    ) {
      checkPaymentStatusMutation.mutate({
        subject_id: data.subject_id,
        subscription_invoice_id: data.subscription_invoice_id,
      });
      polling.current = setInterval(() => {
        checkPaymentStatusMutation.mutate({
          subject_id: data.subject_id,
          subscription_invoice_id: data.subscription_invoice_id,
        });
      }, 3000);
    }
  }, [data]);

  useEffect(() => {
    return () => {
      clearInterval(polling.current);
    };
  }, []);

  return status;
}
